var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 224.89,
  height: 161.785
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "error_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3949",
  d: "M188.349 23.086C178.763 9.63 144.972-12.687 99.5-12S24.342 10.185 36.05 24.789 11.743 42.121 2.329 62.424s10.851 45.811 40.339 56.99 60.149 16.186 91.977 7.852 54.689-22.577 62.551-46.076a64.419 64.419 0 0 0-8.847-58.104Z",
  transform: "matrix(.998 .07 -.07 .998 9.168 0)",
  fill: "url(#error_svg__a)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "error_svg__d"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 940",
  cx: 59.277,
  cy: 59.294,
  rx: 59.277,
  ry: 59.294,
  fill: "#70bea9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "error_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 12966",
  d: "M28.41 0c15.765.068 28.606 14.269 28.68 31.719s-12.645 31.54-28.41 31.472S.075 48.922 0 31.472 12.645-.068 28.41 0Z",
  fill: "#aed0e8"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "error_svg__a",
  cx: 0.728,
  cy: 0.032,
  r: 1.12,
  gradientTransform: "matrix(-.427 .781 -.533 -.625 1.055 -.516)",
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#edf1fc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#dfdff0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error_svg__c",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d9e6fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#dcf1fa"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Empty State Graphic"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4665"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3946",
  d: "M194.413 20.628c19.06 17.706 26.54 10.12 29.866 45.966s-7.211 54.12-24.916 71.778-58.4 25.759-105.5 22.823-63.891-17.344-69.08-22.823S-3.532 98.091.465 74.31s32.7-16.824 42.354-30.245-21-3.625-3.756-23.437 136.29-17.706 155.35 0Z",
  fill: "#f2fbff"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Mask Group 233",
  transform: "translate(9.775 11.983)",
  clipPath: "url(#error_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3945",
  d: "M194.867 20.134c-12.4-15.806-25.226-33.444-55.114-28.929S59.793-2.682 37.161-1.621 12.759 45.927 2.53 67.986s11.79 49.775 43.829 61.921 65.353 17.587 99.935 8.532 52.488-40.628 57.381-59.879 3.59-42.62-8.808-58.426Z",
  transform: "rotate(4.01 134.652 86.326)",
  fill: "url(#error_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3950",
  d: "m154.092 118.044-6.615-6.211 15.94-17.268 6.615 6.211Z",
  fill: "#aed0e8",
  opacity: 0.25
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3951",
  d: "m18.347 78.659 17.608-7.108 4.802 19.7Z",
  fill: "#aed0e8",
  opacity: 0.25
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Mask Group 235",
  transform: "rotate(-90 319.817 71.028)",
  opacity: 0.12,
  clipPath: "url(#error_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Keppel-Dolphin Gradient",
  d: "M55.624-192.902h113.185V65.836H55.624a7 7 0 0 1-7-7v-244.738a7 7 0 0 1 7-7Z",
  fill: "#bad6c9"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Mask Group 236",
  transform: "rotate(-160 122.07 20.27)",
  opacity: 0.25,
  clipPath: "url(#error_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Keppel-Dolphin Gradient",
  d: "m33.667-102.765 47.05.2.589 137.871-47.05-.2a11 11 0 0 1-10.868-10.983l-.5-115.998a10.769 10.769 0 0 1 10.779-10.89Z",
  fill: "#aed0e8"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4668"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11253"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11239"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13015",
  d: "m126.806 100.999-.331-4.473-27.883 1.371v4.316s-6.271 5.967-8.746 45.661h50.191s5.507-35.13-13.231-46.875Z",
  fill: "#7cc3b8"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11238",
  fill: "none",
  stroke: "#474c5e",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 852",
  d: "m98.592 102.213 28.214-1.214"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13016",
  d: "m104.357 120.516 5.779 2.353 3.094 25.006"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11248"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11242"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11240"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13017",
  d: "m68.109 92.352 7.7-25.429 16.943 6.352-8.129 24.353a8.67 8.67 0 0 1-16.517-5.276Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13018",
  d: "M79.99 53.339a9.193 9.193 0 1 1 17.513 5.6l-4.747 14.338-16.943-6.352Z",
  fill: "#c3dfd1"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11241"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13019",
  d: "M81.192 90.444 61.84 53.751s.441-6.629-10.572-7.026v.01c-.15-.007-.3-.021-.449-.021h-3.681a1.394 1.394 0 0 0-1.4 1.159 1.362 1.362 0 0 0 1.178 1.551l3.713.525-5.051 1.348-.943.348-6.872-4.544a1.115 1.115 0 0 0-1.363 1.764c.424.354 1.108.94 1.852 1.583l-1.518-.909a1.115 1.115 0 0 0-1.217 1.867l1.356.955-.528-.206a1.363 1.363 0 0 0-1.616.448 1.311 1.311 0 0 0 .571 1.957l7.517 3.146a6.211 6.211 0 0 0 4.063.52l6.7-1.579 14.983 41.964Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13040",
  d: "m73.249 75.385 3.581 6.79",
  fill: "none",
  stroke: "#474c5e",
  strokeLinecap: "round"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11243"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13020",
  d: "m95.057 46.945-7.193.538S77.448 61.612 98.593 97.897l27.883-1.371 2.1-39.094-3.442-11.1h-12.493Z",
  fill: "#c3dfd1"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13021",
  d: "M86.894 71.077s-2.075-4.364-.742-14.031",
  fill: "none",
  stroke: "#474c5e",
  strokeLinecap: "round",
  strokeMiterlimit: 10
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11247"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11245"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13022",
  d: "m151.62 87.252-11.58-23.913-15.744 8.92 11.824 22.779a8.673 8.673 0 0 0 15.5-7.786Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11244"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13023",
  d: "M133.786 50.573a9.192 9.192 0 1 0-16.422 8.259l6.928 13.421 15.744-8.92Z",
  fill: "#c3dfd1"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 854",
  fill: "none",
  stroke: "#474c5e",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  d: "m124.292 72.254-5.72-11.081"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11246"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13024",
  d: "M175.787 46.337a1.363 1.363 0 0 0-1.616-.448l-3.364 1.313 3.159-2.673a1.347 1.347 0 0 0 .274-1.785 1.312 1.312 0 0 0-1.9-.273l-2.94 2.367 2.506-3.276a1.346 1.346 0 0 0-.114-1.8 1.313 1.313 0 0 0-1.915.139l-4.947 5.134-5.051-1.348 3.714-.525a1.362 1.362 0 0 0 1.178-1.55 1.394 1.394 0 0 0-1.4-1.159h-3.684a8.832 8.832 0 0 0-5.906 2.2c-.027.021-.052.035-.08.057-2.259 1.781-1.437 5.432-1.437 5.432l-13.868 39.264 13.745 6.1 7.924-42.166 5.061.009a5.328 5.328 0 0 0 .943 0h.038a5.38 5.38 0 0 0 1.595-.392l7.517-2.661a1.311 1.311 0 0 0 .568-1.959Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 855",
  fill: "none",
  stroke: "#474c5e",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  d: "m143.785 71.078-2.995 10.456"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11251"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13025",
  d: "M94.497 16.555c-.867.595-7.608.8-7.723 1.854 0 0 .413 8.433-1.546 9.828a16.31 16.31 0 0 0-6.171 10.11s15.576 11.864 52.712.88c0 0 .445-4.449-6.31-7.678a10.627 10.627 0 0 1-4.725-4.2 8.152 8.152 0 0 1-1.189-3.393c-.619-3.662-10.735-17.22-25.048-7.401Z",
  fill: "#7190b6"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13027",
  d: "m97.058 36.669.616 9.685c.209 3.4 1.6 5.719 4.947 5.486 2.857-.2 6.255-2.488 6.412-5.347l-1.7-15.2Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13028",
  d: "m95.057 46.944 17.584-.612s-.428 8.645-10.879 7.836c-7.265-.563-6.705-7.224-6.705-7.224Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13029",
  d: "m97.566 46.647 11.239-10.988-11.829 2.018Z",
  fill: "#474c5e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13030",
  d: "M100.005 40.234c-5.722.017-10.448-4.489-10.619-9.162l-.337-11.027a10.863 10.863 0 0 1 10.1-11.234c5.985-.416 12.223 4.025 12.64 10.009l.174 8.872c.137 6.86-5.112 12.065-11.958 12.542Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13037",
  d: "M102.693 6.916a13.711 13.711 0 0 0-4.246.448c-3.427.913-14.335-5.293-15.892 3.56-1.5 5.377 5.147 8.791 5.147 8.791s13.339 1.662 18.291-2.758c.978 4.141 1.882 6.7 5.972 10.736l3.631-5.458 4.088 3.667c.026.138 1.704-19.461-16.991-18.986Z",
  fill: "#7190b6"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11250"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13038",
  d: "M117.929 27.805a4.453 4.453 0 1 1-4.752-4.133 4.453 4.453 0 0 1 4.752 4.133Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13039",
  d: "M111.787 29.386s-.224-3.221 2.891-2.928",
  fill: "none",
  stroke: "#474c5e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.8
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13090",
  d: "M99.372 9.336s-5.048-5.447-10.286-5.8-8.472 2.214-9.239 4.319a9.32 9.32 0 0 0 1.018 8.153c1.841 2.542 7.2 3.67 7.2 3.67",
  fill: "none",
  stroke: "#7190b6"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13091",
  d: "M98.426 9.097s-5.68 1.029 1.25-1.8 13.548-1.242 16.865 1.221 4.067 5.183 4.878 8.44.472 7.471 2.4 9.537 2.714 2.576 6.629 4.533 3.875 7.034 3.875 7.034",
  fill: "none",
  stroke: "#7190b6"
})))))))));
export default SvgError;